import { GoogleIndexerPrerequisitePanel } from '../components/GoogleIndexerPrerequisitePanel';
import { IndexNowSettingsPanel } from '../components/IndexNowSettingsPanel';
import { NeedProject } from '../components/NeedProject';
import { useProject } from '../lib/project-context';

export function SettingsPage() {
  const { project } = useProject();

  return (
    <div className="d-flex flex-column gap-3">
      {!project ? (
        <NeedProject message="برای تنظیمات، از منوی بالا یک پروژه انتخاب کنید." />
      ) : (
        <>
          <GoogleIndexerPrerequisitePanel />
          <IndexNowSettingsPanel />
        </>
      )}
    </div>
  );
}
